export enum DesignFeatureFlag {
  /** Enable the new way of handling intents for the intent management service APIs. */
  intentManagement = 'intentManagement',
  /** Enable multiple TTS voices per language, which can have different texts on each prompt. */
  ttsOverrides = 'ttsOverrides'
}
